<template>
  <div :class="[isLandscape ? 'promo_common_popup_left_panel' : 'promo_common_popup_left_panel_portrait']">
    <div
      v-for="(item, index) of getPromoActivityList"
      :key="index"
      class="promo_common_popup_left_panel_item"
      @click="() => onSelectActivityClick(item.id)">
      <img v-if="item.isSelected" :src="getCounterPromoImage" alt="" />
      <img v-if="!item.isSelected" :src="getCounterImage" alt="" />
      <div class="promo_common_popup_left_panel_item__name">{{ item.name }}</div>
      <div class="promo_common_popup_left_panel_item__end">{{ $t('common_popup.end_of') }}</div>
      <div class="promo_common_popup_left_panel_item__time">{{ item.time }}</div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { mapGetters } from 'vuex';

export default Vue.extend({
  name: 'ActivePromoPanel',
  props: {
    onSelectActivityHandler: {
      // вызовет клик в род компоненте
      type: Function
    }
  },
  data: () => ({
    timer: 0,
    timeUpdate: 1000
  }),
  mounted() {
    this.startTimer();
  },
  destroyed() {
    this.stopTimer();
  },
  methods: {
    startTimer(): void {
      this.timer = Number(
        setInterval(() => {
          this.timerUpdate();
        }, this.timeUpdate)
      );
    },
    stopTimer(): void {
      clearTimeout(this.timer);
    },
    timerUpdate() {
      this.getPromoActivityList.forEach((el: any) => (el.time = el.updateTimer()));
    },
    onSelectActivityClick: function (index: number) {
      this.onSelectActivityHandler(index);
    }
  },
  computed: {
    ...mapGetters(['getPromoActivityList', 'getAppConfiguration']),
    isLandscape(): boolean {
      return this.getAppConfiguration.isLandscape;
    },
    getCounterImage(): string {
      return `${__PROMO_CONFIG.STATIC_URL}/assets/img/common_popup/counter.png`;
    },
    getCounterPromoImage(): string {
      return `${__PROMO_CONFIG.STATIC_URL}/assets/img/common_popup/counter_promo.png`;
    }
  }
});
</script>

<style scoped>
.promo_common_popup_left_panel {
  overflow-y: auto;
  position: absolute;
  top: 20px;
  left: 19px;
  width: 305px;
  height: 581px;
  padding: 10px;
}

.promo_common_popup_left_panel_portrait {
  display: flex;
  overflow-x: auto;
  overflow-y: auto;
  position: absolute;
  top: 678px;
  left: 10px;
  width: 480px;
  height: 175px;
  padding: 10px;
}

.promo_common_popup_left_panel_item__name {
  font-family: myriadpro-semibold, sans-serif;
  text-align: center;
  position: absolute;
  top: 25px;
  left: 0;
  margin-left: 0;
  margin-right: 0;
  right: 0;
  color: white;
  font-size: 22px;
}

.promo_common_popup_left_panel_item__end {
  font-family: myriadpro-bold, sans-serif;
  text-align: center;
  position: absolute;
  top: 55px;
  left: 0;
  margin-left: 0;
  margin-right: 0;
  right: 0;
  color: white;
  font-size: 16px;
}

.promo_common_popup_left_panel_item__time {
  font-family: myriadpro-boldcond, sans-serif;
  text-align: center;
  position: absolute;
  top: 89px;
  left: 55px;
  margin-left: 10px;
  right: 0px;
  color: white;
  font-size: 30px;
}

.promo_common_popup_left_panel_portrait .promo_common_popup_left_panel_item:not(:last-child) {
  margin-right: 20px;
}
</style>
